export default {
  name: 'SiteList',
};
